import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {StartECaseModule} from "./start-ecase/start-ecase.module";
import {StartECasePreferencesModule} from "./start-ecase-preferences/start-ecase-preferences.module";

export class Bootstrapper {

  static bootstrap(instance: string, options: any) {
    switch(instance) {
      case "start-ecase": {
        platformBrowserDynamic().bootstrapModule(StartECaseModule, options);
      break;
      }
      case "start-ecase-preferences": {
        platformBrowserDynamic().bootstrapModule(StartECasePreferencesModule, options);
        break;
      }
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/bootstrapper.ts